// Funkcja do przypinania nagłówka
window.onscroll = function () {
    fixedHeader();
};

const header = document.querySelector('.header');

function fixedHeader() {
    if (window.pageYOffset > 0) {
        header.classList.add('header--fixed');
    } else {
        header.classList.remove('header--fixed');
    }
}

// Obsługa menu mobilnego po załadowaniu DOM
document.addEventListener("DOMContentLoaded", function () {
    const hamburger = document.querySelector(".js-hamburger");
    const mobileMenu = document.querySelector(".mobile-menu");

    if (hamburger && mobileMenu) {
        let isMenuOpen = false;

        hamburger.addEventListener("click", function () {
            hamburger.classList.toggle("is-active");

            if (!isMenuOpen) {
                // Krok 1: Ustawiamy display, ale nie animujemy jeszcze
                mobileMenu.style.display = "block";
                mobileMenu.classList.remove("is-active");

                // Krok 2: czekamy aż przeglądarka przetworzy display
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        mobileMenu.classList.add("is-active");
                    });
                });

                isMenuOpen = true;
            } else {
                // Krok 1: usuń klasę (start animacji zwijania)
                mobileMenu.classList.remove("is-active");

                // Krok 2: po zakończeniu animacji, schowaj
                setTimeout(() => {
                    mobileMenu.style.display = "none";
                }, 400); // dopasuj do CSS transition
                isMenuOpen = false;
            }
        });
    }
});


